import React from "react";
import { Link } from "@inertiajs/react";
import styled, { css } from "styled-components";
import { narrowScreenMediaQuery, white } from "../constants/styles";
import { StickyHeader } from "../commons/Header";
import Section, { SectionSeparator } from "../commons/Section";
import { OffWhiteTheme } from "../commons/theme_color";

const UnnamedComponent = () => {
  return (
    <React.Fragment>
      <Section>
        <HeroFlex>
          <SectionLeftPart>
            <ProgramTitle>Promosikan Brevet AB/C TLC</ProgramTitle>
            <Title>Dapatkan Komisi Besar Tanpa Batas!</Title>
            <Subtitle>
              Promosikan <HighlightedOrange>Brevet AB/C</HighlightedOrange> TLC,
              dan nikmati komisi{" "}
              <HighlightedOrange>Rp 100.000</HighlightedOrange> untuk setiap
              peserta yang mendaftar lewat kode referral Anda.
              <br />
              <br />
              Keuntungan Bergabung Taxsam Affiliate Program
              <BenefitOl>
                <li>
                  Pendaftaran{" "}
                  <HighlightedOrange>Affiliate Program</HighlightedOrange>{" "}
                  Gratis
                </li>
                <li>Potensi Pendapatan tanpa batas</li>
                <li>
                  Komisi sebesar Rp100.000 setiap peserta yang menggunakan kode
                  referral
                </li>
                <li>Bekerja dimanapun dan Kapanpun</li>
              </BenefitOl>
            </Subtitle>
            <CTALink href="/users/affiliators">Daftar Sekarang</CTALink>
          </SectionLeftPart>
          <SectionRightPart></SectionRightPart>
        </HeroFlex>
      </Section>
      <SecondSection></SecondSection>
      <OffWhiteTheme>
        <Section>
          <TnCTitle>Alur Program Affiliate Taxsam – Brevet AB/C TLC</TnCTitle>
          <TnCOl>
            <li>
              Daftar Program Affiliate
              <TnCOlSub>
                <li>
                  Registrasi sebagai Affiliate melalui website Taxsam.co/TLC.
                  Setelah pendaftaran dikonfirmasi tim Taxsam, Anda akan
                  mendapatkan kode referral unik.
                </li>
              </TnCOlSub>
            </li>
            <li>
              Promosikan Brevet AB/C TLC
              <TnCOlSub>
                <li>
                  Kami akan menyediakan materi promosi (poster, caption, atau
                  konten marketing) yang bisa Anda gunakan untuk membagikan
                  informasi tentang Kelas Brevet AB/C TLC di media sosial,
                  website, atau jaringan Anda. Jangan lupa sertakan kode
                  referral Anda.
                </li>
              </TnCOlSub>
            </li>
            <li>
              Peserta Gunakan Kode Referral Anda
              <TnCOlSub>
                <li>
                  Setiap peserta baru yang mendaftar Brevet AB/C TLC dengan kode
                  referral Anda akan mendapatkan potongan harga khusus.
                </li>
              </TnCOlSub>
            </li>
            <li>
              Dapatkan Komisi Rp100.000 / Peserta
              <TnCOlSub>
                <li>
                  Untuk setiap pendaftaran melalui kode referral Anda, Anda
                  langsung mendapatkan komisi sebesar Rp100.000. Komisi akan
                  terus mengalir selama kode referral dan akun affiliate Anda
                  aktif.
                </li>
              </TnCOlSub>
            </li>
          </TnCOl>
        </Section>
      </OffWhiteTheme>
      <SectionSeparator />
      <OffWhiteTheme>
        <Section>
          <TnCTitle $nomargintop>*Terms and Conditions</TnCTitle>
          <TnCOl>
            <li>
              Pendaftaran Program Afiliasi
              <TnCOlSub>
                <li>
                  Program afiliasi terbuka bagi individu maupun entitas yang
                  memenuhi persyaratan yang ditentukan oleh TLC.
                </li>
                <li>
                  Dengan mendaftar, Anda dianggap telah membaca, memahami, dan
                  menyetujui seluruh Syarat &amp; Ketentuan ini.
                </li>
              </TnCOlSub>
            </li>
            <li>
              Komisi
              <TnCOlSub>
                <li>
                  Mitra afiliasi berhak mendapatkan komisi dari pembayaran yang
                  berhasil direferensikan sesuai dengan aturan komisi yang
                  berlaku.
                </li>
                <li>
                  Besaran komisi, struktur perhitungan, serta metode pembayaran
                  dapat berbeda-beda sesuai ketentuan yang ditetapkan oleh TLC.
                </li>
                <li>
                  Aturan komisi diperbarui secara berkala dan berlaku sejak
                  tanggal diumumkan.
                </li>
              </TnCOlSub>
            </li>
            <li>
              Metode Pembayaran
              <TnCOlSub>
                <li>
                  Komisi akan dibayarkan melalui metode pembayaran yang
                  ditentukan oleh TLC.
                </li>
                <li>
                  Jadwal pembayaran ditetapkan oleh TLC dan dapat berubah
                  sewaktu-waktu dengan pemberitahuan sebelumnya.
                </li>
              </TnCOlSub>
            </li>
            <li>
              Kewajiban Mitra Afiliasi
              <TnCOlSub>
                <li style={{ display: "none" }}>
                  Mitra afiliasi wajib menggunakan materi promosi resmi yang
                  disediakan TLC.
                </li>
                <li>
                  Dilarang menggunakan praktik yang menyesatkan, merugikan, atau
                  melanggar hukum dalam mempromosikan TLC.
                </li>
              </TnCOlSub>
            </li>
            <li>
              Hak TLC
              <TnCOlSub>
                <li>
                  TLC berhak menolak atau menghentikan keikutsertaan mitra
                  afiliasi jika terbukti melanggar ketentuan ini.
                </li>
                <li>
                  TLC berhak memperbarui, mengubah, atau menghentikan Program
                  Afiliasi sewaktu-waktu dengan atau tanpa pemberitahuan
                  sebelumnya.
                </li>
              </TnCOlSub>
            </li>
            <li>
              Batasan Tanggung Jawab
              <TnCOlSub>
                <li>
                  TLC tidak bertanggung jawab atas kerugian langsung maupun
                  tidak langsung yang timbul akibat partisipasi dalam Program
                  Afiliasi.
                </li>
              </TnCOlSub>
            </li>
            <li>
              Perubahan Syarat &amp; Ketentuan
              <TnCOlSub>
                <li>
                  TLC berhak untuk memperbarui Syarat &amp; Ketentuan ini kapan
                  saja. Versi terbaru akan selalu tersedia pada halaman resmi
                  Program Afiliasi TLC.
                </li>
              </TnCOlSub>
            </li>
          </TnCOl>
        </Section>
      </OffWhiteTheme>
    </React.Fragment>
  );
};
export default UnnamedComponent;

const TnCOl = styled.ol`
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 0;
  padding-bottom: 40px;

  & > li {
    margin-bottom: 4px;
  }
`;

const TnCOlSub = styled.ol`
  list-style-type: lower-alpha;
  margin-bottom: 0;
  padding-left: 20px;
`;

const TnCTitle = styled.div`
  color: #e76f51;
  font-size: 14px;
  font-weight: bold;
  padding-top: 20px;
  margin-top: 40px;

  ${(props) =>
    props.$nomargintop &&
    css`
      margin-top: 0;
      padding-top: 40px;
    `}
`;

const SecondSection = styled.div`
  ${StickyHeader} + ${Section} + & {
    background-color: black;
  }
`;

const HeroFlex = styled.div`
  display: flex;
`;

const HighlightedOrange = styled.span`
  color: #ffeb3b;
  font-weight: bold;
`;

const ProgramTitle = styled.h3`
  color: #ffc100;
  letter-spacing: 2px;
  margin-top: 50px;
  text-shadow: 2px 2px 4px #000000e6;
`;

const Title = styled.h1`
  color: ${white};
  font-size: 3rem;
  font-weight: normal;
  line-height: 0.95;
  margin: 50px 0 0 0;
`;

const Subtitle = styled.div`
  color: ${white};
  font-size: 1.2rem;
  font-weight: normal;
  line-height: 1.4;
  margin-top: 30px;
`;

const CTALink = styled(Link)`
  -o-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  background-color: #ec8311;
  border-color: #ce8329;
  border-radius: 0px 0px 0px 0px;
  border-style: solid;
  border-width: 1px 1px 1px 1px;
  color: #ffffff;
  cursor: pointer;
  display: block;
  font-size: 22px;
  font-weight: bold;
  letter-spacing: 0.15px;
  line-height: 1.1em;
  padding: 20px 18px;
  text-align: center;
  text-decoration: none;
  transition: all 0.3s;
  width: 100%;

  &:hover {
    background-color: #ec83114f;
    color: #ffc100;
  }

  @media ${narrowScreenMediaQuery} {
    width: unset;
  }
`;

const SectionPart = styled.div``;

const SectionLeftPart = styled(SectionPart)`
  flex: 3 1 0;

  @media ${narrowScreenMediaQuery} {
    max-width: 90%;
    margin-left: auto;
    margin-right: auto;
  }
`;

const SectionRightPart = styled(SectionPart)`
  flex: 2 1 0;

  @media ${narrowScreenMediaQuery} {
    flex: unset;
  }
`;

const BenefitOl = styled.ol`
  margin-top: 10px;
  padding-bottom: 10px;
`;
